import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Analytics } from "@/components/Analytics";

import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import ServiceAreasPage from "@/pages/ServiceAreasPage";
import ReviewsPage from "@/pages/ReviewsPage";
import FaqPage from "@/pages/FaqPage";
import Contact from "@/pages/Contact";
import QuotePage from "@/pages/QuotePage";
import QuoteSuccess from "@/pages/QuoteSuccess";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cancellation from "@/pages/Cancellation";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function AppRoutes() {
  const location = useLocation();
  // Emergent OAuth returns to /admin#session_id=... — process it before any route/guard runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/service-areas" element={<ServiceAreasPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/quote/success" element={<QuoteSuccess />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cancellation-policy" element={<Cancellation />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BrandingProvider>
            <Analytics />
            <AppRoutes />
            <Toaster position="top-center" richColors closeButton />
          </BrandingProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
